export const BASE_URL_API_DEV = 'https://api.lectoresgalacticos.leer.org.ar' // 'http://lectoresgalacticos.leer.org.ar:8080'
export const DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm:ss"
/*export const BASE_URL_API_DEV = 'http://localhost:8080'*/


// WEBPACK FOOTER //
// src/utils/constants/index.js